import api from 'api'

export const fetchMetrics = async (projectId) => {
  const { data } = await api.get(`/project/${projectId}/metric`)

  return data
}
